<template>
  <div id="VModalFilesUpload">
    <b-modal :id="modalId" :ref="modalId" hide-footer centered hide-backdrop size="xl">
      <template slot="modal-title">
        Добавление файла
      </template>
      <v-workspace :type="wrkspcType" :fileHandler="this.fileHandler"></v-workspace>
    </b-modal>
  </div>
</template>

<script>
const VWorkspace = () => import('@/components/content/edit/Workspace.vue')
export default {
  name: 'ModalFilesUpload',
  components: {
    VWorkspace
  },
  props: {
    wrkspcType: {
      type: String,
      default() {
        return ''
      }
    },
    modalId: {
      type: String,
      default: 'files-upload-modal'
    },
    fileHandler: {
      type: Function
    }
  }
}
</script>

<style scoped>

</style>
